/* eslint-disable sonarjs/no-duplicate-string */
import { useTranslation } from 'react-i18next';

import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';

// TODO: remove translation key mapping here, high bug possibility if key is updated
const WIDGET_TITLES_MAP: Record<string, Record<string, string>> = {
  [WidgetType.o_stewarded_value]: {
    [DefaultWidgetNames.default_stewarded_value_card]: 'global.widget.stewardedValue',
  },
  [WidgetType.o_total_size]: {
    [DefaultWidgetNames.default_total_size_card]: 'global.widget.totalSize',
  },
  [WidgetType.o_ecological_integrity_index]: {
    [DefaultWidgetNames.default_ecological_integrity_card]: 'global.widget.ecologicalIntegrityIndex.title',
  },
  [WidgetType.o_total_assets]: {
    [DefaultWidgetNames.default_total_assets_card]: 'global.widget.totalAssets',
  },
  [WidgetType.o_total_account_value]: {
    [DefaultWidgetNames.default_total_account_value_card]: 'global.widget.totalAccountValue',
  },
  [WidgetType.o_c_nature_health_overview]: {
    [DefaultWidgetNames.default_ecosystem_health_chart]: 'ecosystemHealth.header',
  },
  [WidgetType.o_c_land_distribution_chart]: {
    [DefaultWidgetNames.default_land_distribution_chart]: 'global.widget.landDistribution',
  },
  [WidgetType.o_c_earnings_chart]: {
    [DefaultWidgetNames.default_earnings_chart]: 'global.widget.earnings',
  },
  [WidgetType.o_c_risk_aggregated_overview]: {
    [DefaultWidgetNames.default_climate_risk_aggregated_overview]: 'climateRisk.riskOverview',
  },
  [WidgetType.o_c_resilience_drivers_card]: {
    [DefaultWidgetNames.default_resilience_drivers_card]: 'global.widget.resilienceDrivers.title',
  },
  [WidgetType.o_c_ranked_by_risk_plot_list]: {
    [DefaultWidgetNames.default_ranked_by_risk_plot_list]: 'global.widget.rankingTables.rankedByRisk',
  },
  [WidgetType.o_c_ranked_by_resilience_plot_list]: {
    [DefaultWidgetNames.default_ranked_by_resilience_plot_list]: 'global.widget.rankingTables.rankedByResilience',
  },
  [WidgetType.o_details_graph_card]: {
    asset_social_indicator_card: 'shared.ncaDetail.details.historicDevelopment',
    asset_deforestation_indicator_card: 'shared.ncaDetail.details.historicDevelopment',
    asset_pofh_indicator_card: 'shared.ncaDetail.details.historicDevelopment',
    asset_whc_indicator_card: 'shared.ncaDetail.details.historicDevelopment',
    asset_bgc_indicator_card: 'shared.ncaDetail.details.historicDevelopment',
  },
  [WidgetType.o_fact_summary]: {
    [DefaultWidgetNames.default_fact_card_current_whc]: 'global.widget.currentWhc',
    [DefaultWidgetNames.default_fact_card_historic_water_5y_uplift]: 'global.widget.historic5yAvgWaterUplift',
    [DefaultWidgetNames.default_fact_card_projection_water_1y_uplift]: 'global.widget.projection1yWaterUplift',
    [DefaultWidgetNames.default_fact_card_current_bgc]: 'global.widget.currentBgc',
    [DefaultWidgetNames.default_fact_card_historic_bgc_5y_uplift]: 'global.widget.historic5yAvgBgcUplift',
    [DefaultWidgetNames.default_fact_card_projection_bgc_1y_uplift]: 'global.widget.projection1yBgcUplift',
    [DefaultWidgetNames.default_fact_card_current_pofh]: 'global.widget.currentPofh',
    [DefaultWidgetNames.default_fact_card_historic_pofh_5y_uplift]: 'global.widget.historic5yAvgPofhUplift',
    [DefaultWidgetNames.default_fact_card_projection_pofh_1y_uplift]: 'global.widget.projection1yPofhUplift',
    [DefaultWidgetNames.default_fact_card_carbon_total]: 'global.widget.combinedCarbon',
    [DefaultWidgetNames.default_fact_card_historic_carbon_5y_uplift]: 'global.widget.historic5yAvgAgcUplift',
    [DefaultWidgetNames.default_fact_card_historic_carbon_1y_uplift]: 'global.widget.projection1yCarbonUplift',
    [DefaultWidgetNames.default_fact_card_current_ndvi]: 'shared.ncaDetail.details.ndvi.labels.latestAnalysis',
  },
};

export const getWidgetTitle = ({ name, type }: { name: string; type: string }): string | undefined => {
  return WIDGET_TITLES_MAP[`${type}`]?.[`${name}`] ?? undefined;
};

// TODO: MVP-CW use this function in the widgets where we are hardcoding the titles
export const useWidgetTitle = ({ name, type }: { name: string; type: string }): string | undefined => {
  const { t } = useTranslation();

  const widgetTitle = getWidgetTitle({ name, type });

  if (!widgetTitle) {
    return undefined;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return t(widgetTitle as any);
};
